module.exports = __webpack_public_path__ + "img/huatu.5e8022c7.png";